<template>
	<main id="rating">
		<form>
			<h2>{{currentSession.event && currentSession.event.name}}</h2>
			<i>{{prettyDate}}</i>
			<p><b>{{candidateInfos.name}}</b><br><i>Disponible le : {{candidateInfos.startDate}}<br>
			{{candidateInfos.mail}}</i></p>
			<h3>Appréciation :</h3>
			<span v-for="assement in assessments">
				<input type="radio" v-bind:value="assement.ref" v-bind:id="assement.ref" v-model="assessment" name="assessment">
				<label class="radio" v-bind:for="assement.ref" v-on:touchstart="forceFocus(assement.ref)">{{assement.label}}</label>
			</span>
			<div v-if="showLink">
				<h3>Prise de rendez-vous :</h3>
				<p>
					<a v-bind:href="generateLink" target="_blank" id="external_link">Lien de prise de rendez-vous</a>
				</p>
				<p>
					<input type="checkbox" v-model="appointment" name="appointment" value="true" id="appointment">
					<label for="appointment">Prise de rendez-vous <b>pas</b> effectuée</label>
				</p>
			</div>
			<h3>Remarques :</h3>
			<textarea v-model="note" placeholder="Remarques" v-on:click="scrollToThisInput" name="note"></textarea>
			<button  v-on:click.self.stop.prevent="validateForm()" v-bind:class="isActive ? 'selected' : ''">Sauvegarder</button>
			<div id="validate"></div>
		</form>
	</main>
</template>

<script>
import libs from '@/libs/main.js';
import componentTools from '@/libs/componentTools.js';

export default{
	name: 'ratingDevoTpl',
	data(){
		return {
			assessment : '',
			appointment : false,
			note : null
		};
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex'],
	computed:{
		isActive : function() {
			if(!this.properties || !this.assessment.length) return false;
			return true;
		},
		candidateInfos : function() {
			let infos = this.currentSession.stepsResults && Object.keys(this.currentSession.stepsResults).find(e => e.indexOf('candidateTpl') > -1 && this.currentSession.stepsResults[e].firstName);
			if(infos) infos = this.currentSession.stepsResults[infos];
			return {
				name : infos && infos.firstName + ' ' + infos.lastName,
				mail : infos && infos.mail,
				startDate : infos && libs.prettyDate(this.lang, "digital", infos.startDate)
			};
		},
		prettyDate : function() {
			return libs.prettyDate(this.lang, 'text');
		},
		assessments : function() {
			if(this.properties && Array.isArray(this.properties.assessments) ){
				return this.properties.assessments.map( e => {return {label : e.label, ref : e.ref}});
			}
			return [];
		},
		generateLink : function() {
			//Get candidate infos
			let candidateInfos = this.currentSession.stepsResults && Object.keys(this.currentSession.stepsResults).find(e => e.indexOf('candidateTpl') > -1);
			candidateInfos = this.currentSession.stepsResults[candidateInfos];
			const full_name = candidateInfos.firstName + ' ' + candidateInfos.lastName;
			const mail = candidateInfos.mail;
			//Get candidate pool
			let poolSelect = this.currentSession.stepsResults && Object.keys(this.currentSession.stepsResults).find(e => e.indexOf('singlePoolTpl') > -1);
			poolSelect = this.currentSession.stepsResults[poolSelect] && this.currentSession.stepsResults[poolSelect].pool;
			//Return right calendly link
			const calendar_links = this.properties.calendarLinks && this.properties.calendarLinks[poolSelect];
			const url = (calendar_links && calendar_links.url || '' ) + '?full_name='+(encodeURIComponent(full_name))+'&email='+(encodeURIComponent(mail));
			return url;
		},
		showLink : function() {
			var assessment = this.assessment;
			let first_assessment = this.properties.assessments && this.properties.assessments[0];
			return first_assessment && first_assessment.ref == assessment;
		}
	},
	methods:{
		validateForm : function(){
			var self = this;
			var button = document.getElementsByTagName("button")[0];
			var validate = document.getElementById("validate");
			if(!this.assessment.length) return;
			var out = {
				assessment: this.assessment,
				appointment : this.appointment
			};
			if(typeof(this.note) == 'string' && this.note.trim().length) out.note = this.note.trim();

			let loader = new Promise(resolve => {
				validate.style.display = "block";
				button.classList.add("load");
				button.innerHTML = "";
				setTimeout(resolve, 1000);
			}).then(() => {
				button.classList.remove("load");
				button.classList.add("validate");
				validate.style.opacity = 1;
				return new Promise(resolve => setTimeout(resolve, 1000));
			}).then(() => {
				self.$emit('validateStep', self.$options.name, out);
			});
		},
		scrollToThisInput: function(event){
			return libs.scrollToElem(event.target);
		},
		forceFocus : function(event){
			let label = event.target && event.target.parentElement;
			if(!label || !label.htmlFor) return;
			let input = document.getElementById(label.htmlFor);
			if(!input || !input.click) return;
			input.click();
		}
	},
	created : componentTools.created,
	mounted : componentTools.mounted
};
</script>

<style lang="less">
@import '../assets/less/conf.import.less';
#rating textarea{
	overflow: hidden;
	resize: none;
	width: 100%;
	height: 8vh;
	min-height: 80px;
	font-size: 14px;
	padding: 1%;
	border-radius: 5px;
}
#rating input[type="radio"]{
	display: none;
}
#rating .radio{
	text-transform: uppercase;
	border-radius: 5px;
	font-size: 20px;
	border: 1px solid @cGrey;
	margin-left: 3%;
	display: inline-block;
	font-weight: bold;
	cursor: pointer;
}
#rating input[type="radio"]:checked{
	&+.radio{
		border: none;
		color: @cWhite;
	}
}
.rating input[type="radio"]{
	+ label{
		cursor: pointer;
		position: relative;
		float: right;
		font-size: 20px;
		.star{
			display: none;
			font-size: 28px;
		}
		.star-o{
			font-size: 28px;
			color: @cGrey_Light_3;
		}
		&:hover{
			.star, ~ label .star{
				display: inline;
			}
			.star-o, ~ label .star-o{
				display: none;
			}
		}
	}
	&:checked + label{
		.star, ~ label .star{
			display: inline;
		}
		.star-o, ~ label .star-o{
			display: none;
		}
	}
}
#rating .rating{
	text-align: left;
	li{
		display: inline-block;
		margin: 0;
		width: 49%;
		font-size: 0;
		span{
			display: inline-block;
			font-size: 12px;
			font-weight: bold;
			height: 34px;
			vertical-align: middle;
			width: 45%;
		}

		.stars {
			vertical-align: bottom;
			display: inline-block;
			width: 55%;
		}
	}
}
#rating button{
	transition: 0.250s;
}
#rating button.load {
	background-color: transparent;
	box-shadow: none;
	border: 3px solid @cGrey_Light_3;
	cursor: wait;
	padding: 0;
	border-radius: 40px;
	width: 40px;
	height: 40px;
  	animation: rotating 1s 0.25s linear infinite;
  	&:active{
  		position: relative;
  		top: 0;
  	}
  	div{
		opacity: 0;
	}
}
#rating button.validate {
	background-color: transparent;
	box-shadow: none;
	transition: 0.5s;
	padding: 0;
	width: 40px;
  	animation: rotating 1s 0.25s linear infinite;
	position: relative;
	height: 40px;
}
#rating #validate {
	position: relative;
	top: -21px;
	left: 50%;
	display: none;
	width: 50px;
	transition: 0.5s;
	opacity: 0;
	margin-left: -25px;
	&:after{
		content: "";
		display: block;
		position: relative;
		left: 28%;
		transform: rotate(45deg);
		width: 10px;
		height: 4px;
		top: -2px;
		border-radius: 20px;
	}
	&:before {
		content: "";
		display: block;
		position: relative;
		border-radius: 20px;
		height: 4px;
		width: 20px;
		left: 36%;
		transform: rotate(-42deg);

	}
}
#external_link {
	text-decoration : underline;
}
@keyframes rotating {
	from {
		transform: rotate(0deg);
	}
	to {
	transform: rotate(360deg);
	}
}
// Computer
@media screen
and (min-width: 1025px){
	#rating .radio{
		padding: 20px 25px;
	}
	#rating .rating{
		li{
			&:nth-of-type(2n){
				margin-left: 2%;
			}
		}
	}
}
// Small computer
@media screen
and (max-width: 1024px)
and (min-width: 769px){
	#rating .radio{
		padding: 15px 20px;
	}
	#rating .rating{
		li{
			&:nth-of-type(2n){
				margin-left: 2%;
			}
		}
	}
}
// Tablet
@media screen
and (max-width: 768px)
and (min-width: 481px){
	#rating .radio{
		padding: 15px 20px;

	}
	#rating .rating{
		li{
			&:nth-of-type(2n){
				margin-left: 2%;
			}
		}
	}
}
//  Tablet and smartphone
@media screen
and (max-width: 741px){
	#rating .rating{
		li{
			display: block;
			width: 100%;
			text-align: left;
			span{
				min-width: 120px;
			}
			&:nth-of-type(2n){
				margin-left: 0;
			}
		}
	}
}
// Smartphone
@media screen
and (max-width: 480px){
	#rating .radio{
		padding: 15px 20px;
		&.mobility {
			display: block;
			width: fit-content;
			position: relative;
			left: 50%;
			transform: translateX(-50%);
			margin-bottom: 10px;
		}
	}
	#rating div span:last-of-type .mobility {
		margin-bottom: 0;
	}
	#rating .rating{
		li{
			margin-bottom: 10px;
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/components/ratingDevo.vue